import React from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell'; 
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ReactPaginate from 'react-paginate';
// import Grid from '@material-ui/core/Grid';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import {Link,Router} from 'react-router-dom'
import Button from '@material-ui/core/Button';
import {connect } from 'react-redux';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import Card from '../Dashboard/Card/Card.js'
import CardHeader from "../Dashboard/Card/CardHeader.js";
import CardIcon from "../Dashboard/Card/CardIcon.js";
import CardBody from '../Dashboard/Card/CardBody.js'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import moment from 'moment'
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import * as actionsCreators from  '../../store/actions/index';
class ZoneListing extends React.Component {
    constructor(props) {
        super(props)
        this.state={
            actionMenuOpen : false,
            addActionData : {},
            anchorEl:null,
            open:false,
            limit:10,
            currentSortId:'',
            sortObj : {
                key: '',
                value: ''
            },
            page:1,
            anchorEl_bulk_area             : null,
            placement_area                : '',
            open_bulk_area                : false,
            anchorEl:null,
            open:false,
        }
     
    }
    componentDidMount(){
      let  payload ={
        token:this.props.token,
        page:  1,
        limit: this.state.limit,
        sortName:this.state.sortObj.key,
        sortValue : this.state.sortObj.value,
      }
        this.props.onfetchZoneHeaders(payload)
        this.props.onZonesList(payload);
    }

    handleActionButton = (event,zoneId)=>{
        this.setState({open:!this.state.open,anchorEl:event.currentTarget,zoneId})
    }

    handleClickAway = () => {
        this.setState({open:false});
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        this.setState({page :selectedPage})
        let payload = {
            token: this.props.token,
            page:  selectedPage + 1,
            limit: this.state.limit,
            sortName:this.state.sortObj.key,
            sortValue : this.state.sortObj.value,
        }
        this.props.onZonesList(payload)
    };

    handleSort = (e,sortBy) => {
        let sortObj
        if (this.state.sortObj.key === sortBy.accessor) {
            let value = (this.state.sortObj.value === 'DESC') ? 'ASC' : 'DESC';
            sortObj = {
                key : sortBy.accessor,
                value: value
            }
        } 
        else {
            sortObj = {
                key : sortBy.accessor,
                value: 'DESC'
            }    
            }
    
        this.setState({ sortObj: sortObj ,currentSortId:sortBy.accessor});
        let payload = {
            token: this.props.token,
            sortName:sortObj.key,
            sortValue : sortObj.value,
            page:  this.state.page,
            limit: this.state.limit,
        }
        this.props.onZonesList(payload);
    
          }
          handleClickArea = (newPlacement) => (event) => {
            this.setState({ anchorEl_bulk_area:event.currentTarget, placement_area:newPlacement, open_bulk_area:!this.state.open_bulk_area});
        };
        handleClickAwayBulkArea = () => {
            this.setState({open_bulk_area: false});
        };

    render() {
        let updatedHeaders = this.props.headers
    
        const headers =  !!updatedHeaders && updatedHeaders.map(header => {
            {
                return <TableCell key={header.header} className={"white-space"}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        whiteSpace: 'break-spaces',
                        height:'3em'
                        }}>
                             <div onClick={(e) =>  this.handleSort(e,header)}>
                {header.accessor ==='actionButton' || header.accessor === 'Name_tn' ? '' :    <div>{
                this.state.currentSortId===header.accessor? this.state.sortObj.value ==='ASC'?(<ArrowDropDownIcon fontSize="small"/>):(<ArrowDropUpIcon fontSize="small"/>) :(<ArrowDropDownIcon fontSize="small"/>)}
                </div>}
                </div>
                        {header.header}
                    </div>
                </TableCell>
              }
          });

        const zones =!!this.props.ZoneListing&& this.props.ZoneListing.map((zone, j)=>{
        const zoneId = zone["Id"]
        return <TableRow style={{whiteSpace: 'normal',
        wordWrap: 'break-word'}} key={j}>{
        !!updatedHeaders&&updatedHeaders.map((header, i)=>{
        if(header.accessor=='actionButton'){
         return  <TableCell  key={i}>
            <IconButton
            aria-label="more"
            aria-controls="long-menu"
            aria-haspopup="true"
            onClick={(e)=>this.handleActionButton(e,zoneId)}
            >
            <MoreVertIcon fontSize='small'/>
            </IconButton>
                <Popper
                    open={this.state.open} anchorEl={this.state.anchorEl}>
                    <ClickAwayListener onClickAway={this.handleClickAwayEdit}>
                    <Paper style={{boxShadow:"none", border:"1px solid #3dab35"}}>
                        <MenuList>
                            <Link to={`./edit_zone/${this.state.zoneId}`} className='email_link'> <MenuItem>Edit</MenuItem></Link>
                            <Link to={`./viewWard/${this.state.zoneId}`} className='email_link'> <MenuItem>View Ward</MenuItem></Link>
                        </MenuList>
                        <MenuList>
                        {/* <Link to={`./property_loads/${this.state.propertyId}`} className='email_link'> <MenuItem>Show Loads</MenuItem></Link> */}
                        </MenuList>
                    </Paper>
                    </ClickAwayListener>
                </Popper>
            </TableCell>
        }
        else{
            return  <TableCell style={{
                whiteSpace: "normal",
                wordWrap: "break-word"
                }} key={i} className={"white-space"}>{zone[header.accessor] == null || zone[header.accessor] == 'null' ? ' ' : zone[header.accessor]}</TableCell>
            }
         }) 
        }
        </TableRow>
        }) 
        return (
            <div>
                <div className="dashboard_right_content" style={{marginTop:'-4%'}}>
                    <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                    <div className="dashboard_right_content_top">
                    <h5> Zone Listing</h5>
                   
                        <div className="dashboard_right_content_top_options">
                        {localStorage.getItem('isZoneNotRequired') === 'true'? <Link className="email_link" to='/ward-management'><Button>Ward Listing</Button></Link> :<> 
                            <Link className="email_link" to='/add_zone'><Button>Add Zone</Button></Link> </> }
                        <>
                        <Button className="email_link"
                                ref={this.state.anchorRef}
                                aria-controls={this.state.open ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                onClick={this.handleClickArea('bottom')}
                                style={{height:'35px', marginLeft:'20px'}}>
                              Wards&nbsp;
                                {
                                    this.state.open ?   <ArrowDropUpIcon /> : <ArrowDropDownIcon/> 
                                }
                                
                            </Button>
                            <Popper style={{zIndex:"10"}} open={this.state.open_bulk_area} anchorEl={this.state.anchorEl_bulk_area} placement={this.state.placement_area} transition>
                            {({ TransitionProps }) => (
                                    <ClickAwayListener onClickAway={this.handleClickAwayBulkArea}>
                                <Paper style={{zIndex:1, border:"1px solid #3dab35"}}>
                                    <MenuList>
                                    <Link className="email_link"  to={`/viewWard/all`} ><MenuItem> UnAssigned Ward</MenuItem> </Link>
                                
                                    <Link className="email_link" to='/add_ward'> <MenuItem >Add Ward</MenuItem></Link>  
                                 
                                    </MenuList>
                                </Paper>
                                </ClickAwayListener>
                            )}
                            </Popper>
                            </>  
                        {/* <Link className="email_link" to='/add_ward'><Button>Add Ward</Button></Link>    */}
                        </div>
                    </div>
                </div>
                <div className="dashboard_listing AreaLIsting" >
                        <TableContainer component={Paper} style={{paddingLeft:"15px",paddingRight:"15px"}}>
                             <Table stickyHeader aria-label="sticky table" style={{ tableLayout: 'fixed' }}>
                                <TableHead >
                                    <TableRow >
                                        {headers}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                 {zones}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                       {
                this.props.totalCount && this.props.totalCount != 0 && 
                    <ReactPaginate
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount = {10}
                    pageCount = {this.props.totalCount/this.state.limit}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    style={{borderLeftWidth:'0px'}}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}/>
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
        return {
        token: state.auth.token,
        headers:state.ZoneListingreducer.ZoneHeader && state.ZoneListingreducer.ZoneHeader.concat({header: "Action", accessor: "actionButton", sortable: "false", filter: "true"}),
        ZoneListing: state.zoneReduce.zone,
        totalCount:state.zoneReduce.totalCount
       
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onfetchZoneHeaders: (payload) => dispatch(actionsCreators.fetchZoneHeaders(payload)),
        onZonesList : (payload)=>dispatch(actionsCreators.ZonesList(payload))
    }
}

export default  connect(mapStateToProps, mapDispatchToProps)(ZoneListing);